import styled from 'styled-components';
import { colors } from '../../../style/styleSettings';

const Label = styled.label`
  font-size: 15px;
  color: ${colors.MID_GREY};
`;

export default Label;
